// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageLinkAnimationFunc() {
  var scrTop, jsAnkerLogin, moveLogin, position, target, getHeadH;
  scrTop = $('#scrPageTop');
  scrTop.on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1500, 'easeInOutQuint');
    return false;
  });
}

export function pageMoveAnkerFunc() {
  var headerHeight, position;
  $('a[href^="#"]:not(.notScroll)').each(function () {
    var pageUrl = location.href.split('#')[0];
    if (this.href.indexOf(pageUrl + '#') === 0) {
      var id = this.href.split('#')[1];
      $(this).on('click', function () {
        let resizecheck = $('#responsibleCheck').width();
        if(resizecheck == 2){
          headerHeight = $('#header').outerHeight(true);
        }else{
          headerHeight = 0;
        }
        
        position = $('#' + id).offset().top - headerHeight;
        $('body,html').animate({
          scrollTop: position
        }, 1000, 'easeInOutQuart');
        return false;
      });
    }
  });
}

export function strengthJsFunc() {
  var urlHash = location.hash;
  var resizeFunc,resizecheck;
  resizecheck = $('#responsibleCheck').width();
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    
    //強みページになっていたら
    if ( urlHash.match(/open/)) {
        let accordionBox = $(urlHash);
        accordionBox.find('dt').toggleClass('selected');
        accordionBox.find('dd').slideToggle();
    }
    
    setTimeout(function () {
      // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
      var headerHight = 0;
      console.log(resizecheck);
      if(resizecheck != '1'){
        headerHight = 87;
      }
      
      var target = $(urlHash);
      var position = target.offset().top - headerHight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 1000, 'easeInOutQuart');
    }, 100);
  }
}